import { render, staticRenderFns } from "./js-number-dialog.vue?vue&type=template&id=3b66a988&scoped=true"
import script from "./js-number-dialog.vue?vue&type=script&lang=js"
export * from "./js-number-dialog.vue?vue&type=script&lang=js"
import style0 from "./js-number-dialog.vue?vue&type=style&index=0&id=3b66a988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b66a988",
  null
  
)

export default component.exports